// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2JNZj","colMin":"styles_colMin__3uFha","colCheckbox":"styles_colCheckbox__1_Hfe"};